import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api, IMAGES } from "@/lib/data";
import { Reveal } from "@/components/Reveal";

export default function Article() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0 });
    api.get(`/articles/${slug}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) return (
    <main className="pt-40 pb-24 container-edge min-h-screen">
      <h1 className="font-display text-4xl text-primary mb-4">Article not found</h1>
      <Link to="/knowledge" className="text-accent">← Back to Knowledge Bank</Link>
    </main>
  );

  if (!article) return <main className="pt-40 pb-24 container-edge min-h-screen text-muted-foreground">Loading…</main>;

  const fmt = (d) => new Date(d).toLocaleDateString("en-GB", { day: "2-digit", month: "long", year: "numeric" });

  return (
    <main data-testid="article-page" className="bg-background">
      <div className="relative h-[52vh] min-h-[380px] overflow-hidden">
        <img src={article.cover_image || IMAGES.document} alt={article.title} className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-background via-background/60 to-primary/30" />
        <div className="container-edge absolute inset-x-0 bottom-0 pb-12">
          <span className="overline">{article.category} — {fmt(article.created_at)}</span>
          <h1 className="font-display font-light text-4xl md:text-6xl tracking-tight text-primary max-w-4xl mt-4">{article.title}</h1>
        </div>
      </div>

      <article className="container-edge py-20">
        <Link data-testid="back-to-knowledge" to="/knowledge" className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-accent mb-12 hover:gap-3 transition-all">
          <ArrowLeft size={16} /> Knowledge Bank
        </Link>
        <div className="max-w-2xl mx-auto">
          <Reveal>
            <p className="text-xl md:text-2xl font-display text-foreground/80 leading-relaxed mb-10 border-l-2 border-accent pl-6">{article.excerpt}</p>
            {article.body.split("\n\n").map((p, i) => (
              <p key={i} className={`text-lg text-foreground/80 leading-[1.9] mb-6 ${i === 0 ? "drop-cap" : ""}`}>{p}</p>
            ))}
            <div className="mt-12 pt-8 border-t border-border text-sm text-muted-foreground">Written by {article.author}</div>
          </Reveal>
        </div>
      </article>
    </main>
  );
}
